








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { GenderDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxGender extends Vue {
  private types: GenderDto[] | null = [];
  public selectedType = new GenderDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: GenderDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: GenderDto) {
    this.$emit("genderSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .gender_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
